export function isRefund(payment) {
	return payment && payment.transactionType === 'REFUND';
}

export function signedPaymentAmount(payment, amount = payment && payment.amount) {
	amount = amount || 0;
	return isRefund(payment) ? -Math.abs(amount) : amount;
}

export function grossPaymentTotal(invoice) {
	if (!invoice) return 0;
	if (invoice.grossPaymentTotal != null) return invoice.grossPaymentTotal;
	return (invoice.paymentTotal || 0) + (invoice.refundTotal || 0);
}
